import { generateKeyBetween as fiKeyBetween, generateNKeysBetween as fiNKeysBetween } from "fractional-indexing";

/**
 * Ключи порядка (fractional indexing). Общий keyspace для `nodes.position`
 * и `node_placements.position` — вплетение встаёт между родными детьми.
 *
 * Здесь только чистая генерация ключей. Advisory-локи контейнера, ребаланс в транзакции
 * и retry на коллизию — серверные, живут в `packages/core`.
 */

/**
 * Порог длины ключа, после которого набор соседей перенумеровывается ровными ключами
 * в той же транзакции. Ребаланса по расписанию нет — только по требованию
 * (spec-tasks Область 8). Значение выбрано при реализации, см. docs/impl-log.md.
 */
export const POSITION_KEY_LENGTH_THRESHOLD = 48;

export function generateKeyBetween(a: string | null, b: string | null): string {
	return fiKeyBetween(a, b);
}

export function generateNKeysBetween(a: string | null, b: string | null, n: number): string[] {
	return fiNKeysBetween(a, b, n);
}

export function needsRebalance(key: string): boolean {
	return key.length > POSITION_KEY_LENGTH_THRESHOLD;
}

/**
 * Единственный порядок сортировки аутлайна — `position, id`.
 * Вторичный ключ не косметика: два писателя (браузер и агент) могут получить одинаковый
 * `position`, и без `id` порядок был бы «как вернёт БД» (spec-tasks Область 8).
 */
export function comparePositions(a: { position: string; id: string }, b: { position: string; id: string }): number {
	if (a.position !== b.position) {
		return a.position < b.position ? -1 : 1;
	}
	return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}

export function sortByPosition<T extends { position: string; id: string }>(items: readonly T[]): T[] {
	return [...items].sort(comparePositions);
}
